import { memo, type ReactNode, useMemo } from 'react';
import { Provider } from 'react-redux';

import { makeStore } from '~/store';

export type PublicShowcaseReduxProviderProps = {
  children: ReactNode;
};

export const PublicShowcaseReduxProvider = memo(({ children }: PublicShowcaseReduxProviderProps) => {
  const { store } = useMemo(() => {
    const { store } = makeStore();

    return { store };
  }, []);

  return <Provider store={store}>{children}</Provider>;
});

PublicShowcaseReduxProvider.displayName = 'PublicShowcaseReduxProvider';
